var map = {
	"./6_Monate_Garantie.png": 2493,
	"./Akkutausch.png": 5213,
	"./Akkutausch.webp": 3879,
	"./Anfrage.webp": 4550,
	"./Banner.jpg": 5094,
	"./Banner.png": 4434,
	"./Banner.webp": 9867,
	"./Displaytausch.png": 2583,
	"./Displaytausch.webp": 7901,
	"./EinsendenNeu.png": 2035,
	"./EinsendenNeu.webp": 8439,
	"./EmailBild.png": 5752,
	"./EmailBild.webp": 8443,
	"./Garantie.png": 182,
	"./Garantie.webp": 6420,
	"./Gorilla4.png": 4671,
	"./Gorilla4.webp": 1237,
	"./Mac.png": 508,
	"./Mac.webp": 6267,
	"./MacAir.png": 8798,
	"./MacAir.webp": 5140,
	"./MacAndPhoneLogo.svg": 5685,
	"./MacPro.png": 5303,
	"./MacPro.webp": 33,
	"./Macbook_Reparatur.png": 2482,
	"./Macbook_Reparatur.webp": 8189,
	"./Notfall-Hotline.png": 5442,
	"./Notfall-Hotline.webp": 2745,
	"./Notfall_Hotline.svg": 7785,
	"./Notfall_Hotline.webp": 1590,
	"./Schutzfolie.png": 9011,
	"./Schutzfolie.webp": 2280,
	"./Smartphone-Reparatur.png": 7940,
	"./Smartphone-Reparatur.webp": 138,
	"./Smartphone.png": 1730,
	"./Smartphone.webp": 2229,
	"./VorOrtNeu.png": 5347,
	"./Wasserschaden.jpg": 919,
	"./Wasserschaden.webp": 310,
	"./WienSvg.png": 2704,
	"./WienSvg.webp": 4182,
	"./ansatz.jpg": 8755,
	"./ansatz.webp": 3934,
	"./backgroundRepBeschreibung.png": 8628,
	"./backgroundRepBeschreibung.webp": 6785,
	"./checkbox.svg": 8024,
	"./iMac.png": 2714,
	"./iMac.webp": 1700,
	"./iPad-Reparatur.png": 3748,
	"./iPad-Reparatur.webp": 2299,
	"./iPad.png": 3612,
	"./iPad.webp": 2768,
	"./iPhone-Reparatur.png": 9746,
	"./iPhone-Reparatur.webp": 4275,
	"./iPhone.png": 4396,
	"./iPhone.webp": 888,
	"./iPhone11.png": 4089,
	"./iPhone11.webp": 644,
	"./iWatch.png": 5682,
	"./iWatch.webp": 8537,
	"./icon1.png": 8535,
	"./icon1.webp": 4548,
	"./icon2.png": 171,
	"./icon2.webp": 9097,
	"./icon3.png": 8752,
	"./icon3.webp": 9981,
	"./magnifying-glass.svg": 5358,
	"./noNeed/DocRepairingPhone.png": 8958,
	"./noNeed/Gorilla.png": 9655,
	"./noNeed/Gorilla2.png": 1893,
	"./noNeed/Gorilla3.png": 4326,
	"./noNeed/KontaktBild.png": 2675,
	"./noNeed/Top.jpg": 5340,
	"./noNeed/Zusenden.jpeg": 911,
	"./noNeed/ansatz.jpg": 873,
	"./noNeed/asdas.png": 8211,
	"./noNeed/dd.png": 2800,
	"./noNeed/iWatch copy.png": 5333,
	"./noNeed/logo.svg": 4682,
	"./noNeed/nee.png": 2919,
	"./noNeed/prinzipien.jpg": 1937,
	"./noNeed/prozess.jpg": 5180,
	"./paperPlane.svg": 4819,
	"./prinzipien.jpg": 2956,
	"./prinzipien.webp": 825,
	"./prozess.jpg": 2050,
	"./prozess.webp": 7494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9491;